import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [name, setKeyword] = useState('');

  const filterData = () => {
    onFilter(name);
    document.getElementById('closeModal').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Judul Promosi</label>
              <input
                type="text"
                onChange={(e) => setKeyword(e.target.value)}
                className="form-control"
                value={name}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
